$shm_tests_app $mol_book2_catalog
	menu_title \Результаты тестов
	param \test_scenario
	menu_filter_enabled true
	Group* $mol_list
		rows <= group_rows* /$mol_view
	Group_row* $mol_view
		sub /
			<= Group_expand* $mol_check_expand
				checked? <=> group_expanded*? true
				expandable <= group_expandable* true
			<= Group_title* $mol_view
				sub /
					<= group_title* \
	Group_children* $mol_list
		rows <= group_scenario_rows* /$mol_view
	Scenario_node* $mol_view
		sub <= scenario_node_content* /$mol_view
	Scenario_guide_vertical* $mol_view
		style * bottom <= scenario_guide_bottom* \0px
	Scenario_guide_horizontal* $mol_view
	Scenario* $mol_book2
		pages <= scenario_pages* /$mol_view
	Scenario_panel* $shm_tests_scenario
		display_title <= scenario_title* \
		result <= selected_result* null
		player <= scenario_player* null
		versions <= run_versions* *
		run_id? <=> selected_run*? \
		benchmarks_open? <=> benchmarks_open*? false
		screenshots_open? <=> screenshots_open*? false
	Scenario_step* $shm_tests_app_run
		display_title <= scenario_title* \
		result <= selected_result* null
		comparison_results <= comparison_results* /
		manifest_uri <= selected_manifest_uri* \
	Scenario_benchmarks* $shm_tests_benchmarks
		display_title <= scenario_title* \
		results <= comparison_results* /
	Scenario_screenshots* $shm_tests_screenshots
		result <= selected_result* null
		manifest_uri <= selected_manifest_uri* \
	Releases $shm_tests_release
	Releases_link $mol_link
		arg *
			test_scenario \releases
			test_run null
			test_benchmarks null
			test_screenshots null
		title \Проекты и релизы
	Empty $mol_page
		title \Результатов пока нет
		body /
			<= Empty_text $mol_paragraph
				title \Запустите Playwright-сценарий, использующий shm/hitalama/playwright/harness.js.
